var React = require('react');

function UiArrowDown (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Arrow Down"),React.createElement("path",{"d":"M11.3,15L0.9,4.5c-1.1-0.9-1.1-2.5-0.2-3.6c0.9-1.1,2.5-1.1,3.6-0.2c0.1,0.1,0.1,0.1,0.2,0.2l6.9,6.8l6.9-6.9\n\tc0.9-1.1,2.5-1.1,3.6-0.2c1.1,0.9,1.1,2.5,0.2,3.6c-0.1,0.1-0.1,0.1-0.2,0.2L11.3,15z","key":1})]);
}

UiArrowDown.defaultProps = {"role":"presentation","version":"1.1","x":"0px","y":"0px","viewBox":"0 0 22.7 15","style":{"enableBackground":"new 0 0 22.7 15"},"xmlSpace":"preserve"};

module.exports = UiArrowDown;

UiArrowDown.default = UiArrowDown;
